import { render, staticRenderFns } from "./ActionCarrierAuswahlen.vue?vue&type=template&id=117a4831&scoped=true&"
import script from "./ActionCarrierAuswahlen.vue?vue&type=script&lang=js&"
export * from "./ActionCarrierAuswahlen.vue?vue&type=script&lang=js&"
import style0 from "./ActionCarrierAuswahlen.vue?vue&type=style&index=0&id=117a4831&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a4831",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VDialog,VSpacer})
